module.exports = __webpack_public_path__ + "img/wechat.70684d30.png";